var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2016_2037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0615 0L18.4028 0.0598826C22.8039 0.410528 26.8744 2.49577 29.7819 5.81061C35.5622 12.3997 35.3586 22.2058 29.4346 28.5726C23.0069 35.4811 12.2286 35.8444 5.35851 29.3717C2.33196 26.5193 0.394537 22.6263 0.0598791 18.3999L0 18.0626L0.0252823 15.9481C0.604779 7.3589 7.3618 0.610137 15.9451 0.0246184L18.0615 0ZM19.498 20.402C23.5298 20.5238 26.8032 23.6516 27.1618 27.6312C32.9242 22.1572 33.2575 13.115 28.0008 7.21186C22.273 0.779139 12.2985 0.608806 6.35051 6.82861C0.745162 12.6904 0.92746 22.0182 6.83619 27.6298C7.18948 23.6483 10.4788 20.5304 14.4788 20.402H19.4986H19.498ZM24.927 29.3977L24.925 28.1548C24.8312 25.1287 22.3608 22.6722 19.323 22.6722H14.6757C11.6372 22.6722 9.16749 25.1281 9.07234 28.1548L9.08033 29.399C13.9106 32.5076 20.0861 32.5122 24.927 29.3977Z",
    fill: "#2024BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7322 6.80868C19.8998 6.65631 22.5132 9.13146 22.6589 12.1915C22.8073 15.3153 20.3908 17.9655 17.2944 18.1252C14.176 18.2868 11.5128 15.8796 11.3418 12.777C11.1708 9.67905 13.5546 6.96171 16.7329 6.80868H16.7322ZM16.3343 9.13878C14.4255 9.52003 13.2898 11.3651 13.6777 13.1802C14.0636 14.986 15.8407 16.1517 17.6344 15.8044C19.4813 15.4471 20.6909 13.6566 20.3356 11.8308C19.9803 10.0051 18.2325 8.75952 16.3343 9.13811V9.13878Z",
    fill: "#2024BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2016_2037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfo);
export default __webpack_public_path__ + "static/media/personal-info.d42e90b30d66f110b0c672f39d233e86.svg";
export { ForwardRef as ReactComponent };